import FreeSens from "assets/img/freesensLittle.svg";
import styles from "assets/css/Invitaion.module.css";
import {Grid} from "@mui/material";
import Button from "@mui/material/Button";
import {useSendResponse} from "hooks/useInvitations";
import {useState} from "react";

export const InvitationPart = ({nameOfDoctor, id, setRequestStatus}) => {
    const sendResponse = useSendResponse()
    const [disable, setDisable] = useState(false)

    const handleButtonResponseClick = (isAccepted) => {
        if (disable) return;
        sendResponse.mutate({isAccepted, id, setRequestStatus})
        setDisable(true)
    }

    return (
        <Grid container>
            <img src={FreeSens} style={{margin: '24px auto 94px'}} alt='FreeSens logo'/>
            <p className={styles.invitationText}> شما از طرف دکتر <span
                className={styles.purple}>{nameOfDoctor}</span>{' '}
                به عنوان دستیار ثبت نام شده اید </p>
            <p className={styles.invitationText}>این ثبت نام را تایید میکنید؟</p>

            <Grid item xs={6} className={styles.centerContainer}>
                <Button onClick={() => handleButtonResponseClick(true)}
                        className={`${styles.registerButton} ${disable && styles.disableStyle}`}>تایید ثبت نام</Button>
            </Grid>
            <Grid item xs={6} className={styles.centerContainer}>
                <Button onClick={() => handleButtonResponseClick(false)}
                        className={`${styles.cancelButton} ${disable && styles.disableStyle}`}>انصراف</Button>
            </Grid>
        </Grid>
    )
}